import { render, staticRenderFns } from "./InvoiceHistoryTableForm.vue?vue&type=template&id=4e160dfa"
import script from "./InvoiceHistoryTableForm.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports